export default {
  title: 'Home',
  welcome: {
    title: 'Welcome {name}',
    subtitle: 'Manage your video content, channels, and analytics all in one place',
    memberSince: 'Member since {date}',
    upgradeButton: 'Upgrade to Pro',
    upgradeSubtitle: 'Unlock all features'
  },
  apps: {
    title: 'Our tools',
    description: 'Explore our powerful tools to create, manage and share your content.',
    comingSoon: 'Coming soon'
  },
  tutorials: {
    title: 'Our tutorials',
    description: 'Our help center guides you through using our solution.',
    viewAll: 'Help Center',
    unlockPro: 'Unlock Pro',
    items: {
      gettingStarted: {
        title: 'Getting Started',
        description: 'Discover the basic features and get started quickly'
      },
      uploadVideo: {
        title: 'Upload a Video',
        description: 'Learn how to upload and organize your video content'
      },
      sellVideos: {
        title: 'Sell Your Videos',
        description: 'Monetize your content with our integrated sales tools'
      }
    }
  },
  blog: {
    title: 'Blog',
    description: 'Follow our news, updates and video tips.',
    viewAll: 'View all blog',
    categories: {
      product: 'Product',
      tips: 'Tips',
      bestPractices: 'Best Practices',
      data: 'Data'
    },
    articles: {
      webTvGuide: {
        title: 'Launch an Internal Web TV: Complete Guide to Engage Your Teams',
        excerpt: 'From channel structuring to rights management, discover how to deploy a high-performance and secure internal Web TV.'
      },
      subtitlesBestPractices: {
        title: 'Automatic Subtitling: 5 Best Practices for Professional Results',
        excerpt: 'Improve accessibility and SEO of your videos with these simple tips to optimize your subtitles.'
      },
      organizeMediaLibrary: {
        title: 'How to Organize Your Media Library: Tags, Folders, and Spaces',
        excerpt: 'A clear method to structure your media and speed up daily searches.'
      },
      videoAnalytics: {
        title: 'Video Analytics: Metrics That Really Matter',
        excerpt: 'Completion rate, engagement, traffic sources... make your data speak.'
      }
    }
  },
  quickActions: {
    title: 'Quick Actions',
    uploadAssets: 'Upload Assets',
    uploadAssetsDesc: 'Add new videos and media',
    createChannel: 'Create Channel',
    createChannelDesc: 'Start a new video channel',
    createShowcase: 'Create Showcase',
    createShowcaseDesc: 'Build a presentation page',
    viewAnalytics: 'View Analytics',
    viewAnalyticsDesc: 'Check your performance'
  },
  recentActivity: {
    title: 'Recent Activity',
    uploadedVideo: 'Uploaded a new video',
    createdChannel: 'Created a new channel',
    publishedShowcase: 'Published a showcase',
    startedStream: 'Started a live stream',
    minutesAgo: '{count} minutes ago',
    hoursAgo: '{count} hours ago',
    daysAgo: '{count} days ago'
  },
  faq: {
    title: 'FAQ',
    description: 'Find answers to frequently asked questions',
    items: {
      monetization: {
        question: 'How to monetize my content?',
        answer: 'You can monetize your videos through direct sales, subscriptions, or integration on a paid channel.'
      },
      addContent: {
        question: 'How to add content to my channel?',
        answer: 'Click on "Add video" from your dashboard or drag and drop your files directly.'
      },
      secureSharing: {
        question: 'Can I share a video securely with someone?',
        answer: 'Yes, you can generate a private link with password or validity period.'
      },
      embedVideos: {
        question: 'Can I embed Videas videos on my website?',
        answer: 'Of course. Each video can be embedded via responsive embed code.'
      },
      addSubtitles: {
        question: 'How to add subtitles to my video?',
        answer: 'Go to the "Subtitles" tab of a video to import or automatically generate files.'
      }
    }
  },
  recentMedia: {
    title: 'Recent Media',
    description: 'Quickly access your latest files to organize, share or analyze.',
    emptyState: {
      title: 'No recent media',
      description: 'Upload your first file to see it appear here.',
      uploadButton: 'Upload media'
    },
    table: {
      file: 'File',
      space: 'Space',
      type: 'Type',
      addedDate: 'Added'
    }
  }
}
